// Tradución del namespace `ra.*` de react-admin 5.14 al español (neutro, LatAm).
// Misma estructura de claves que `../pt-br.ts` → `ra`. Los placeholders %{...} y el
// separador de plural |||| son obligatorios.
const raEs = {
    action: {
        select_all_button: 'Seleccionar todo',
        add_filter: 'Agregar filtro',
        add: 'Agregar',
        back: 'Volver',
        bulk_actions:
            '%{smart_count} elemento seleccionado |||| %{smart_count} elementos seleccionados',
        cancel: 'Cancelar',
        clear_array_input: 'Vaciar la lista',
        clear_input_value: 'Borrar valor',
        clone: 'Duplicar',
        confirm: 'Confirmar',
        create: 'Crear',
        create_item: 'Crear %{item}',
        delete: 'Eliminar',
        edit: 'Editar',
        export: 'Exportar',
        list: 'Listar',
        refresh: 'Actualizar',
        remove_filter: 'Quitar filtro',
        remove: 'Eliminar',
        remove_all_filters: 'Quitar todos los filtros',
        save: 'Guardar',
        search: 'Buscar',
        select_all: 'Seleccionar todo',
        select_row: 'Seleccionar fila',
        show: 'Mostrar',
        sort: 'Ordenar',
        undo: 'Deshacer',
        expand: 'Expandir',
        close: 'Cerrar',
        open_menu: 'Abrir menú',
        close_menu: 'Cerrar menú',
        unselect: 'Deseleccionar',
        update: 'Actualizar',
        move_up: 'Subir',
        move_down: 'Bajar',
        open: 'Abrir',
        toggle_theme: 'Alternar modo claro/oscuro',
        select_columns: 'Columnas',
        update_application: 'Recargar aplicación',
        reset: 'Restablecer',
        search_columns: 'Buscar columnas',
    },
    boolean: {
        true: 'Sí',
        false: 'No',
        null: '',
    },
    page: {
        access_denied: 'Acceso denegado',
        authentication_error: 'Error de autenticación',
        create: 'Crear %{name}',
        dashboard: 'Tablero',
        edit: '%{name} #%{id}',
        error: 'Ocurrió un problema',
        list: '%{name}',
        loading: 'Cargando',
        not_found: 'No encontrado',
        show: '%{name} #%{id}',
        empty: 'Todavía no hay elementos.',
        invite: '¿Desea agregar uno?',
    },
    input: {
        file: {
            upload_several:
                'Suelte archivos para subir, o haga clic para seleccionar uno.',
            upload_single:
                'Suelte un archivo para subir, o haga clic para seleccionarlo.',
        },
        image: {
            upload_several:
                'Suelte imágenes para subir, o haga clic para seleccionar una.',
            upload_single:
                'Suelte una imagen para subir, o haga clic para seleccionarla.',
        },
        references: {
            all_missing:
                'No fue posible encontrar los datos de referencia.',
            many_missing:
                'Al menos una de las referencias asociadas ya no parece estar disponible.',
            single_missing:
                'La referencia asociada ya no parece estar disponible.',
        },
        password: {
            toggle_visible: 'Ocultar contraseña',
            toggle_hidden: 'Mostrar contraseña',
        },
        autocomplete: {
            no_options_text: 'Ninguna opción encontrada',
        },
    },
    message: {
        access_denied: 'No tiene permiso para acceder a esta página',
        authentication_error:
            'El servidor de autenticación devolvió un error y no fue posible verificar sus credenciales.',
        placeholder_data_warning: 'Problema de red: error al actualizar los datos.',
        select_all_limit_reached:
            'Hay demasiados elementos para seleccionarlos todos. Solo se seleccionaron los primeros %{max} elementos.',
        about: 'Acerca de',
        are_you_sure: '¿Está seguro?',
        auth_error:
            'Ocurrió un error con el token de autenticación.',
        bulk_delete_content:
            '¿Está seguro de que desea eliminar este %{name}? |||| ¿Está seguro de que desea eliminar estos %{smart_count} elementos?',
        bulk_delete_title:
            'Eliminar %{name} |||| Eliminar %{smart_count} %{name}',
        bulk_update_content:
            '¿Está seguro de que desea actualizar %{name}? |||| ¿Está seguro de que desea actualizar estos %{smart_count} elementos?',
        bulk_update_title:
            'Actualizar %{name} |||| Actualizar %{smart_count} %{name}',
        clear_array_input: '¿Está seguro de que desea vaciar toda la lista?',
        delete_content: '¿Está seguro de que desea eliminar este elemento?',
        delete_title: 'Eliminar %{name} #%{id}',
        details: 'Detalles',
        error:
            'Ocurrió un error en el navegador y su solicitud no pudo completarse.',
        invalid_form:
            'El formulario no es válido. Por favor, verifique los errores',
        loading: 'La página se está cargando, espere un momento',
        no: 'No',
        not_found: 'Escribió una URL incorrecta, o no tiene permiso para acceder a esta página',
        yes: 'Sí',
        unsaved_changes:
            'Algunos de sus cambios no fueron guardados. ¿Está seguro de que desea descartarlos?',
    },
    navigation: {
        clear_filters: 'Limpiar filtros',
        no_filtered_results: 'No se encontraron resultados',
        no_results: 'No se encontraron resultados',
        no_more_results:
            'El número de página %{page} está fuera de los límites. Intente con la página anterior.',
        page_out_of_boundaries: 'La página %{page} está fuera de los límites',
        page_out_from_end: 'No es posible ir más allá de la última página',
        page_out_from_begin: 'La página no puede ser menor que 1',
        page_range_info: '%{offsetBegin}-%{offsetEnd} de %{total}',
        partial_page_range_info:
            '%{offsetBegin}-%{offsetEnd} de más de %{offsetEnd}',
        current_page: 'Página %{page}',
        page: 'Ir a la página %{page}',
        first: 'Ir a la primera página',
        last: 'Ir a la última página',
        next: 'Siguiente',
        prev: 'Anterior',
        previous: 'Ir a la página anterior',
        page_rows_per_page: 'Filas por página:',
        skip_nav: 'Saltar al contenido',
    },
    sort: {
        sort_by: 'Ordenar por %{field} %{order}',
        ASC: 'ascendente',
        DESC: 'descendente',
    },
    auth: {
        email: 'Correo electrónico',
        auth_check_error: 'Inicie sesión para continuar',
        user_menu: 'Perfil',
        username: 'Usuario',
        password: 'Contraseña',
        new_password: 'Nueva contraseña',
        confirm_password: 'Confirme la contraseña',
        sign_in: 'Iniciar sesión',
        sign_in_error: 'Error de autenticación, por favor intente de nuevo',
        logout: 'Cerrar sesión',
    },
    notification: {
        updated: 'Elemento actualizado |||| %{smart_count} elementos actualizados',
        created: 'Elemento creado',
        deleted:
            'Elemento eliminado |||| %{smart_count} elementos eliminados',
        bad_item: 'Elemento incorrecto',
        item_doesnt_exist: 'El elemento no existe',
        http_error: 'Error de comunicación con el servidor',
        data_provider_error:
            'Error del servidor. Comuníquese con soporte para este problema.',
        i18n_error:
            'No fue posible cargar las traducciones para el idioma especificado',
        canceled: 'Acción cancelada',
        logged_out: 'Su sesión ha finalizado, por favor vuelva a conectarse.',
        not_authorized: "No tiene autorización para acceder a este recurso.",
        application_update_available: 'Hay una nueva versión disponible.',
        offline: 'Sin conexión. No fue posible cargar los datos.',
    },
    validation: {
        required: 'Obligatorio',
        minLength: 'Debe tener al menos %{min} caracteres',
        maxLength: 'Debe tener como máximo %{max} caracteres',
        minValue: 'Debe ser como mínimo %{min}',
        maxValue: 'Debe ser como máximo %{max}',
        number: 'Debe ser un número',
        email: 'Debe ser un correo electrónico válido',
        oneOf: 'Debe ser uno de: %{options}',
        regex: 'Debe cumplir con un formato específico (regexp): %{pattern}',
        unique: 'Debe ser único',
    },
    saved_queries: {
        label: 'Filtros guardados',
        query_name: 'Nombre del filtro',
        new_label: 'Guardar como filtro...',
        new_dialog_title: 'Guardar filtro como',
        remove_label: 'Eliminar filtro',
        remove_label_with_name: 'Eliminar filtro "%{name}"',
        remove_dialog_title: '¿Eliminar filtro guardado?',
        remove_message:
            '¿Está seguro de que desea eliminar este filtro guardado?',
        help: 'Filtrar y guardar este filtro',
    },
    configurable: {
        customize: 'Personalizar',
        configureMode: 'Configurar esta página',
        inspector: {
            title: 'Inspector',
            content: 'Pase el mouse sobre los elementos para configurarlos',
            reset: 'Restablecer configuración',
            hideAll: 'Ocultar todos',
            showAll: 'Mostrar todos',
        },
        Datagrid: {
            title: 'Lista',
            unlabeled: 'Columna sin nombre #%{column}',
        },
        SimpleForm: {
            title: 'Formulario',
            unlabeled: 'Campo sin nombre #%{input}',
        },
        SimpleList: {
            title: 'Lista',
            primaryText: 'Texto principal',
            secondaryText: 'Texto secundario',
            tertiaryText: 'Texto terciario',
        }
    }
};

export default raEs;
